class SessionService {
    setItem(name: string, stateName: string) {
        return sessionStorage.setItem(name, stateName)
    }

    getItem(name: string) {
        return sessionStorage.getItem(name)
    }

    hasItem(name: string) {
        return sessionStorage.getItem(name) ? true : false
    }

    clear(name?: string) {
        return sessionStorage.clear()
    }

    stringify(stateName: object | Array<string | number>) {
        return JSON.stringify(stateName)
    }

    parse(name: string) {
        return JSON.parse(name!)
    }

    removeItem(name: string) {
        return sessionStorage.removeItem(name)
    }
}

export default new SessionService()
